(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

(function ($) {
  $(document).on('click', '.tabs-v1-trigger', function (e) {
    var that = $(this);
    var taget = that.data('id');

    if (that.hasClass('active')) {
      return false;
    } else {
      that.parents('.tabs-v1').find('.tabs-v1-trigger').removeClass('active');
      that.addClass('active');
      that.parents('.tabs-v1').find('.tabs-v1-content__item').slideUp('slow');
      $(taget).slideDown('slow');
    }
  });
})(jQuery);

},{}]},{},[1]);
